export default "__VITE_ASSET__9xOgBMjm__"